import AddMyCompanyUserPage from './AddMyCompanyUser';
import { createAddMyCompanyUserHandle } from './handle';

export default {
  Component: AddMyCompanyUserPage,
  createHandle: createAddMyCompanyUserHandle
};
